import React from 'react';
import { Testimonial } from './types';
import { ScrollingColumn } from './ScrollingColumn';
interface TestimonialsProps {
  title?: string;
  subtitle?: string;
  description?: string;
  testimonials?: Testimonial[];
  'data-id'?: string;
}
const defaultTestimonials: Testimonial[] = [{
  id: '1',
  name: 'Marcus T.',
  role: 'Investor',
  company: 'Atlanta, GA',
  avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: "Closed my first deal within 3 weeks of signing up. Didn't expect it to work that fast honestly.",
  verified: true
}, {
  id: '2',
  name: 'Sarah C.',
  role: 'Wholesaler',
  company: 'Houston, TX',
  avatar: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'This replaced like 20 hours a week of manual work for me. I actually have my weekends back now.',
  verified: true
}, {
  id: '3',
  name: 'David R.',
  role: 'Fix & Flip',
  company: 'Phoenix, AZ',
  avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: "Was skeptical but my response rate literally tripled. The offers don't sound like spam which I think is the difference.",
  verified: true
}, {
  id: '4',
  name: 'Jen M.',
  role: 'Firm Owner',
  company: 'Dallas, TX',
  avatar: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'We run 3 markets now with the same team size. Would not have been possible before this.',
  verified: true
}, {
  id: '5',
  name: 'Rob K.',
  role: 'Investor',
  company: 'Seattle, WA',
  avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'One deal paid for like 3 years of the subscription. Not every month is a home run but the pipeline stays full.',
  verified: true
}, {
  id: '6',
  name: 'Amanda F.',
  role: 'Buy & Hold',
  company: 'Memphis, TN',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: "I was losing leads left and right before this. Now everything's in one place and I actually follow up on time.",
  verified: true
}, {
  id: '7',
  name: 'James W.',
  role: 'Investor',
  company: 'Charlotte, NC',
  avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'The auto follow-ups alone are worth it. I used to forget to call people back and it was costing me deals.',
  verified: true
}, {
  id: '8',
  name: 'Lisa P.',
  role: 'Flipper',
  company: 'Tampa, FL',
  avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Found 2 off-market properties my first month that I never would have seen otherwise. Pretty wild.',
  verified: true
}, {
  id: '9',
  name: 'Mike B.',
  role: 'Rental Investor',
  company: 'Indianapolis, IN',
  avatar: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Added 5 doors to my portfolio this year. Spend way less time prospecting and more time on the actual properties.',
  verified: true
}, {
  id: '10',
  name: 'Emily T.',
  role: 'Wholesaler',
  company: 'Columbus, OH',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: "Closing rate went way up. I think it's because the offers actually sound like a real person wrote them.",
  verified: true
}, {
  id: '11',
  name: 'Dan L.',
  role: 'Analyst',
  company: 'Denver, CO',
  avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: "The data and analytics are really solid. We can actually see what's working and what's not by market.",
  verified: true
}, {
  id: '12',
  name: 'Rachel S.',
  role: 'Investor',
  company: 'Nashville, TN',
  avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?ixlib=rb-4.0.3&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
  content: 'Honestly just nice to have something that works without babysitting it. Set it up and it runs.',
  verified: true
}];
export function Testimonials({
  title = 'Success Stories',
  subtitle = 'What Clients Say About AcquireFlow',
  description = "Join 200+ investors who are closing more deals with AcquireFlow. Here's what they have to say about their experience.",
  testimonials = defaultTestimonials,
  'data-id': dataId
}: TestimonialsProps) {
  // Split testimonials into three columns
  const column1 = testimonials.slice(0, 4);
  const column2 = testimonials.slice(4, 8);
  const column3 = testimonials.slice(8, 12);
  return <div className="relative w-full flex justify-center items-center py-24 md:py-32 px-6 md:px-8 overflow-hidden" data-id="element-1678">
      <div className="relative max-w-[1280px] w-full flex flex-col items-center gap-12 md:gap-16" data-id="element-1679">
        {/* Header Section */}
        <div className="w-full flex flex-col items-center gap-6 text-center px-4 animate-fadeIn" data-id="element-1680">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#3ab795]/10 border border-[#3ab795]/20 backdrop-blur-sm" data-id="element-1681">
            <div className="w-2 h-2 rounded-full bg-[#3ab795] animate-pulse" data-id="element-1682" />
            <p className="text-sm md:text-base font-medium text-[#3ab795] tracking-wide uppercase" data-id="element-1683">
              {title}
            </p>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#1D1D1D] tracking-tight leading-tight max-w-4xl" data-id="element-1684">
            {subtitle}
          </h2>
          <p className="text-lg md:text-xl leading-relaxed text-gray-600 max-w-2xl font-light" data-id="element-1685">
            {"Join 30+ investors who are closing more deals with AcquireFlow. Here's what they have to say about their experience."}
          </p>
        </div>
        {/* Testimonials Columns */}
        <div className="flex gap-4 md:gap-6 items-center justify-center w-full overflow-x-auto lg:overflow-x-visible scrollbar-hide" data-id="element-1686">
          <div className="flex gap-4 md:gap-6 lg:flex-nowrap" data-id="element-1687">
            <ScrollingColumn testimonials={column1} direction="up" speed={15} data-id="element-1688" />
            <ScrollingColumn testimonials={column2} direction="down" speed={15} data-id="element-1689" />
            <ScrollingColumn testimonials={column3} direction="up" speed={15} data-id="element-1690" />
          </div>
        </div>
      </div>
    </div>;
}